import { marked } from 'marked';

export default function Markdown({ children, ...rest }) {
  const content = children && typeof children === 'string'
    ? marked.parse(children, { breaks: true }) : '';
  return <div dangerouslySetInnerHTML={{__html: content}} {...rest} />;
}
